// extracted by mini-css-extract-plugin
export var active = "_4i-7";
export var container = "_4i-0";
export var evenWidth = "_4i-4";
export var large = "_4i-5";
export var outlet = "_4i-8";
export var slide = "_4i-2";
export var small = "_4i-6";
export var tab = "_4i-3";
export var tabs = "_4i-1";